import { TOUR_FLIGHT_SEARCH_FIXTURE } from 'checkout/fixtures/tourFlightSearch'
import { countOccupantsForFlights } from 'lib/offer/occupancyUtils'

/** Build the two searches from booked tour data, using fixture values only where needed. */
export function buildTourFlightSearch(tourItems: Array<App.Checkout.TourV2Item>, homeAirportCode?: string) {
  const rooms = tourItems.map(item => item.occupancy)
  const occupancies = rooms.length ? [countOccupantsForFlights(rooms)] : TOUR_FLIGHT_SEARCH_FIXTURE.departing.occupancies

  return {
    departing: {
      ...TOUR_FLIGHT_SEARCH_FIXTURE.departing,
      itinerary: [{
        ...TOUR_FLIGHT_SEARCH_FIXTURE.departing.itinerary[0],
        departureAirport: homeAirportCode ?? TOUR_FLIGHT_SEARCH_FIXTURE.departing.itinerary[0].departureAirport,
      }],
      occupancies,
    },
    returning: {
      ...TOUR_FLIGHT_SEARCH_FIXTURE.returning,
      itinerary: [{
        ...TOUR_FLIGHT_SEARCH_FIXTURE.returning.itinerary[0],
        arrivalAirport: homeAirportCode ?? TOUR_FLIGHT_SEARCH_FIXTURE.returning.itinerary[0].arrivalAirport,
      }],
      occupancies,
    },
  }
}
